import React from "react";
import { Helmet } from "react-helmet-async";
import RetailHome from "./retail";
import useHome from "src/swr/hooks/Home/useHome";
import FunLoader from "src/components/Loaders/FunLoader";
import OnLoadError from "src/components/UI/OnLoadError";
import VendorHome from "./vendor";
import ManagerHome from "./manager";
import useGlobalStore from "src/store/useGlobalStore";

const REPORT_IDENTIFIERS = {
  retail_admin_home_report: RetailHome,
  vendor_admin_home_report: VendorHome,
  "single-location": ManagerHome,
  "multi-location": ManagerHome,
};

const Home = () => {
  const config = useGlobalStore((state) => state.config);
  const { data, isLoading, isError } = useHome();

  if (isLoading) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <FunLoader />
      </div>
    );
  }

  if (isError) {
    return <OnLoadError />;
  }

  const HomeComponent = REPORT_IDENTIFIERS[data?.report_identifier];

  return (
    <>
      <Helmet title="Spiffy | Home" />
      <HomeComponent config={config} data={data} />
    </>
  );
};

export default Home;
